





































import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../../../Mixins/ModelSetter'
import CreateIfEmpty from '../../../../../../CreateIfEmpty.vue'
import { UseFields } from '../../../../../../Pi'
import { SelectOptionData } from '../../../../../../Pi/types'
// import { FlowFormButtonStruct } from './index'

@Component({
  components: { CreateIfEmpty }
})
export default class FlowFormButtonSetupView extends Mixins<ModelSetter, UseFields>(ModelSetter, UseFields) {
  @VModel() model!: any

  @Prop() getForms!: () => Array<SelectOptionData>

  @Prop() createFormButtonCallback!: () => void
}
